import { render, staticRenderFns } from "./IOSSuccessStep2.vue?vue&type=template&id=7133b588&scoped=true&"
import script from "./IOSSuccessStep2.vue?vue&type=script&lang=js&"
export * from "./IOSSuccessStep2.vue?vue&type=script&lang=js&"
import style0 from "./IOSSuccessStep2.vue?vue&type=style&index=0&id=7133b588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7133b588",
  null
  
)

export default component.exports